export default "__VITE_ASSET__CRXFjnKI__"